import {
  Button,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Grid,
  Paper,
  Typography,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import * as qs from 'query-string';
import React from 'react';

import { Account, App, CreditCard, Payline, helpers } from '@aps-management/primapp-common';

import { Screen } from '_components/core';
import { Alert, CreditCardPreview, DialogPaymentIP, PaylineWidgetFrame } from '_components/elements';
import apolloClient from '_utils/apolloClient';
import store from '_config/store';

import { PAYLINE_FLOW_TYPES, isExpectedPaylineOrigin } from '../../services/payline';

/* */
const styles = (theme) => ({
  panel: {
    display: 'inherit',
  },
  paper: {
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px`,
  },
  alert: {
    marginTop: theme.spacing.unit * 2,
  },
});

class ChangeCreditCard extends React.Component {
  /* */
  constructor(props) {
    super(props);

    this.authorizationAmount = 100;

    this.state = {
      // ux
      error: null,
      success: null,
      loading: true,
      expanded: false,
      isIframeReturn: false,
      // Traitement serveur en cours, après le retour du widget. Distinct de `loading`,
      // qui ne couvre que le chargement initial de l'écran.
      waiting: false,
      status: null,
      // data
      golf: null,
      account: null,
      imprint: null,
      paylineToken: null,
    };

    this.paylineWidgetData = null;
    this.isPaylinePaymentHandled = false;
    this.removePaylineListeners = null;
  }

  /* */
  componentDidMount() {
    if (window !== window.parent) {
      if (window.location.search.includes('payline_action=')) {
        const urlParams = new URLSearchParams(window.location.search);
        const action = urlParams.get('payline_action');
        const token = urlParams.get('token') || urlParams.get('paylinetoken');

        window.parent.postMessage(
          JSON.stringify({
            type: action === 'cancel' ? 'PAYLINE_CANCEL' : 'PAYLINE_SUCCESS',
            data: { token },
          }),
          '*',
        );
        this.setState({ isIframeReturn: true });
        return;
      }
    }

    this.load()
      .catch((error) => this.setState({ error }))
      .finally(() => this.setState({ screenLoading: false }));

    window.addEventListener('message', this.handlePaylineMessage);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handlePaylineMessage);
  }

  static loadPaylineScript = () =>
    new Promise((resolve, reject) => {
      if (window.Payline?.Api) {
        resolve();
        return;
      }

      const existingScript = document.getElementById('payline-widget-script');
      if (existingScript) {
        existingScript.addEventListener('load', resolve);
        existingScript.addEventListener('error', reject);
        return;
      }

      const script = document.createElement('script');
      script.id = 'payline-widget-script';
      script.src = 'https://payment.cdn.payline.com/cdn/scripts/widget-min.js';
      script.async = true;
      script.addEventListener('load', resolve);
      script.addEventListener('error', reject);
      document.body.appendChild(script);
    });

  handlePaylineMessage = (event) => {
    try {
      // Contrôle d'origine : sans lui, n'importe quel document capable de poster un
      // message à cette fenêtre déclenchait le traitement de succès Payline.
      if (!isExpectedPaylineOrigin(event.origin)) return;

      const msg = JSON.parse(event.data);

      if (msg.type === 'PAYLINE_SUCCESS') {
        this.handlePaylinePaymentSuccess(msg.data);
      } else if (msg.type === 'PAYLINE_ERROR') {
        this.handlePaylinePaymentError(msg.data, 'Le paiement a échoué. Veuillez réessayer.');
      } else if (msg.type === 'PAYLINE_CANCEL') {
        this.handlePaylinePaymentError(msg.data, 'Le paiement a été annulé.');
      }
    } catch (e) {
      console.warn('Failed to parse Payline message:', e);
    }
  };

  /* */
  load = async () => {
    const { token } = qs.parse(this.props.location.search);

    if (!token) {
      throw new Error('Lien erroné.');
    }

    const account = await Account.api.getAccountByToken(apolloClient, {
      token,
    });
    if (!account) throw new Error('Client inexistant.');

    const matching = account.matches.find((m) => (m.token === token ? m : false));

    const { golf } = await App.api.getGolfInfo(apolloClient, {
      id: matching.golfId,
    });
    document.title = (golf && golf.name) || 'prima.golf';

    store.dispatch({ type: 'app/LOAD_GOLF', payload: { ...golf, options: {} } });

    const newState = {};
    const { creditCards } = await CreditCard.api.getCreditCards(apolloClient, {
      accountId: account.id,
    });

    if (creditCards[0]) {
      const status = CreditCard.functions.getStatus(creditCards[0].dueDate);
      newState.imprint = {
        ...status,
        ...creditCards[0],
      };
      newState.expanded = status.isExpired || status.isSoonExpired;
    }

    return this.setState({
      golf,
      account,
      loading: false,
      ...newState,
    });
  };

  /* */
  handleExpand = (e, expanded) => this.setState({ expanded });

  /* */
  handleSubmit = (values, { setSubmitting, resetForm }) => {
    const { id3D = null } = values;
    const { account } = this.state;

    const uuid = helpers.uuid.createUuid();

    const creditCard = {
      ...values,
      name: '3DS web',
      number: values.number.replace(/\s/g, ''),
      dueDate: values.dueDate.replace(/\D/g, ''),
    };

    this.setState({ error: null, success: null });

    return (
      Payline.api
        .createSubscriber(apolloClient, {
          id3D,
          uuid,
          reference: account.id,
          amount: this.authorizationAmount,
          creditCard: helpers.object.filterByKeys(creditCard, ['number', 'dueDate', 'cvv']),
        })
        .catch((err) => {
          throw Object.assign(err, { handled: true });
        })
        // Enregistrement cc
        .then((res) =>
          CreditCard.api.setCreditCard(apolloClient, {
            id: uuid,
            token: res.token,
            accountId: account.id,
            number: CreditCard.functions.anonymizeNumber(creditCard.number),
            ...helpers.object.filterByKeys(creditCard, ['name', 'dueDate', 'type', 'brand', 'country']),
          }),
        )
        .catch((err) => {
          if (!err.handled) {
            throw Object.assign(err, {
              handled: true,
              message: 'Impossible d’enregistrer la carte. Veuillez réessayer ultérieurement.',
            });
          }
          throw err;
        })
        .then(() => {
          this.setState({
            expanded: false,
            imprint: creditCard,
            success: 'Votre carte est enregistrée avec succès.',
          });
          resetForm();
        })
        .catch((err) => this.setState({ error: err.message }))
        .finally(() => setSubmitting(false))
    );
  };

  // Verrou de ré-entrée SYNCHRONE : bloque un 2e tap avant que le rendu ne masque le bouton.
  _cardRegisterInFlight = false;

  payWithNewCardPayline = () => {
    if (this._cardRegisterInFlight) return Promise.resolve();
    this._cardRegisterInFlight = true;
    const { account } = this.state;
    const timestamp = Number(new Date());
    const shortId = account.id.split('-')[0];
    const reference = `CC-${shortId}-${timestamp}`;
    const baseUrl = window.location.href.split('?')[0];
    const returnUrl = `${baseUrl}?payline_action=success`;
    const cancelUrl = `${baseUrl}?payline_action=cancel`;

    this.setState({
      error: null,
      success: null,
      paylineToken: null,
    });

    return Payline.api
      .getToken(apolloClient, {
        amount: this.authorizationAmount,
        reference,
        returnUrl,
        cancelUrl,
        callbackUrl: `${returnUrl.split('?')[0]}?payline_action=callback`,
        action: '100',
      })
      .then((res) => {
        if (!res?.token) {
          throw new Error('Token de paiement introuvable.');
        }

        this.setState({ paylineToken: res.token });
        this.paylineWidgetData = {
          token: res.token,
          accountId: account.id,
          reference,
        };
        this.isPaylinePaymentHandled = false;
      })
      .catch((err) => {
        this.setState({
          error: err.message,
          paylineToken: null,
        });
      })
      .finally(() => {
        this._cardRegisterInFlight = false;
      });
  };

  handlePaylinePaymentSuccess = (eventData = {}) => {
    if (this.isPaylinePaymentHandled || !this.paylineWidgetData) {
      return;
    }

    this.isPaylinePaymentHandled = true;

    const { account } = this.state;
    const data = this.paylineWidgetData;
    const token = eventData?.token || data.token;
    const uuid = helpers.uuid.createUuid();

    this.setState({
      error: null,
      success: null,
      // L'iframe a déjà navigué vers la page de retour, qui ne rend rien : la laisser
      // montée affichait un cadre blanc de 800 px pendant tout le traitement serveur.
      paylineToken: null,
      waiting: true,
      status: 'Vérification du paiement...',
    });

    return Payline.api
      .captureWithToken(apolloClient, {
        amount: this.authorizationAmount,
        token,
        reference: data.reference,
        uuid,
        customer: {
          firstName: account.firstname,
          lastName: account.lastname,
          email: account.email,
        },
      })
      .then((result) => {
        if (!result) {
          throw new Error('Impossible de finaliser le paiement Payline.');
        }

        const cardBrand = result.cardBrand || result.brand;
        const dueDateRaw = result.expiryDate || result.expirationDate || result.cardExpiryDate || '';
        const dueDate = dueDateRaw.replace(/\D/g, '') || '0000';
        const maskedCardNumber = (result.maskedCardNumber || result.card || '****').replace(/X/g, '*');

        const imprint = {
          id: uuid,
          token: result.token || result.transactionId || token,
          name: 'Payline web',
          number: maskedCardNumber,
          dueDate,
          type: '',
          brand: cardBrand,
          country: result.cardCountry,
          // `result.walletId` vaut null quand la création du wallet Payline a échoué. Le
          // repli sur `uuid` qui vivait ici enregistrait alors un wallet inexistant chez
          // Monext : la carte franchissait tous les garde-fous et échouait à chaque
          // prélèvement. On propage l'absence, le serveur laisse `wallet_id` NULL et la
          // carte n'est simplement pas proposée en 1 clic (cf. audit du 28/07, chaîne 2).
          walletId: result.walletId || null,
          paymentRecordId: result.transactionId,
        };

        this.setState({ status: 'Enregistrement de la carte...' });

        return CreditCard.api
          .setCreditCard(apolloClient, {
            id: imprint.id,
            token: imprint.token,
            accountId: data.accountId,
            number: imprint.number,
            name: imprint.name,
            dueDate: imprint.dueDate,
            type: imprint.type,
            brand: imprint.brand,
            country: imprint.country,
            walletId: imprint.walletId,
            paymentRecordId: imprint.paymentRecordId,
          })
          .then(() => imprint);
      })
      .then((imprint) => {
        const status = CreditCard.functions.getStatus(imprint.dueDate);
        this.setState({
          expanded: false,
          imprint: {
            ...status,
            ...imprint,
          },
          paylineToken: null,
          waiting: false,
          status: null,
          success: 'Votre carte est enregistrée avec succès.',
        });
      })
      .catch((err) => {
        this.isPaylinePaymentHandled = false;
        this.setState({
          error: err.message,
          paylineToken: null,
          waiting: false,
          status: null,
        });
      });
  };

  handlePaylinePaymentError = (eventData = {}, defaultMessage = 'Le paiement a échoué. Veuillez réessayer.') => {
    this.setState({
      paylineToken: null,
      waiting: false,
      status: null,
      error: eventData?.message || defaultMessage,
    });
    this.isPaylinePaymentHandled = false;
  };

  /* */
  renderImprint() {
    const { imprint } = this.state;
    const { classes } = this.props;

    return (
      <Grid item xs={12} sm={9} md={6}>
        {imprint ? (
          <>
            <Typography gutterBottom variant='h6' component='h2'>
              {'Ma carte bancaire'}
            </Typography>
            <CreditCardPreview brand={imprint.brand} dueDate={imprint.dueDate} number={imprint.number} />
            {imprint.isExpired && (
              <Alert variant='error' className={classes.alert}>
                {'La carte est expirée.'}
              </Alert>
            )}
            {imprint.isSoonExpired && (
              <Alert variant='warning' className={classes.alert}>
                {'La carte arrive bientôt à expiration.'}
              </Alert>
            )}
          </>
        ) : (
          <Typography gutterBottom variant='h6' component='h2'>
            {'Aucune carte bancaire enregistrée.'}
          </Typography>
        )}
      </Grid>
    );
  }

  /* */
  renderForm() {
    const { classes } = this.props;
    const { golf, imprint, expanded, paylineToken } = this.state;

    const paylineForm = (
      <>
        {paylineToken ? (
          <PaylineWidgetFrame
            token={paylineToken}
            options={{ flowType: PAYLINE_FLOW_TYPES.SAVE_CARD }}
            title='Payline Widget'
          />
        ) : (
          <Button color='primary' variant='contained' onClick={this.payWithNewCardPayline}>
            {'Ajouter/Enregistrer ma carte'}
          </Button>
        )}
      </>
    );

    return (
      <Grid item xs={12} sm={9} md={6}>
        {imprint ? (
          <ExpansionPanel expanded={expanded} onChange={this.handleExpand}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant='subtitle1' component='h2'>
                {'Changer de carte'}
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className={classes.panel}>
              {paylineForm}
            </ExpansionPanelDetails>
          </ExpansionPanel>
        ) : (
          <Paper className={classes.paper}>
            <Typography gutterBottom variant='subtitle1' component='h2'>
              {'Ajouter une carte'}
            </Typography>
            <br />
            {paylineForm}
          </Paper>
        )}
      </Grid>
    );
  }

  /* */
  render() {
    if (this.state.isIframeReturn) {
      return null;
    }

    const {
      // ux
      error,
      loading,
      success,
      waiting,
      status,
      // data
      golf,
      account,
    } = this.state;

    if (!account || !golf) return null;

    return (
      <Screen noDrawer error={error} success={success} loading={loading}>
        <div>
          <Typography variant='h5' gutterBottom>
            {golf.name}
          </Typography>
          <Typography variant='subtitle1' gutterBottom>
            {'Votre moyen de paiement'}
          </Typography>
          <br />
          <Typography gutterBottom>
            {'Bonjour '}
            <b>{`${account.firstname} ${account.lastname}`}</b>
            {','}
          </Typography>
          <Typography gutterBottom>
            {"Afin d'assurer le règlement de vos mensualités, veuillez vérifier l'état de votre carte bancaire."}
          </Typography>
          <Typography>
            <u>{'Rappel'}</u>
            {
              ' : l\'ensemble des prélèvements effectués pour le compte de votre golf apparaîtront sous la mention "GOLF PRIMA" sur votre relevé bancaire.'
            }
          </Typography>
        </div>
        <br />
        <Grid container spacing={40} justify='center'>
          {this.renderImprint()}
          {this.renderForm()}
        </Grid>
        <DialogPaymentIP open={waiting} status={status} />
      </Screen>
    );
  }
}

export default withStyles(styles)(ChangeCreditCard);
